module.exports = __webpack_public_path__ + "static/media/housing_society_2.d86a79dd.svg";